// Error: 'React' was used before it was defined  @typescript-eslint/no-use-before-define
// So use: // eslint-disable-next-line
// This issule just begin (14/09/2020)
// https://github.com/typescript-eslint/typescript-eslint/issues/2540

// Import package from NPM
// eslint-disable-next-line
import React, { useEffect, useState } from 'react';
import { Menu, Tooltip as AntdTooltip, Modal, Button } from 'antd';
import { Link, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
  TAB_SIZE_MINI,
  THEME_TYPE_LITE,
} from '../../constants/ThemeSetting';
import { onNavStyleChange, toggleCollapsedSideNav } from '../../appRedux/actions/setting-actions';

// Import custom by Template
import SidebarLogo from './SidebarLogo';
import IntlMessages from '../../util/IntlMessages';

// Import custom by Project
import { setPathName } from 'appRedux/actions';
import { AppState } from 'ReducerState';
import { API_URL_V1, API_PMS_HEADERS, API_URL_V3 } from 'constants/ApiSetting';
import { checkSession } from 'appRedux/actions/Auth';
import { useResponsive } from 'components/responsive';

// Import custom of this components
import { findMenuActive } from '../../routes/main/route';
import { isNull, isUndefined, isEmpty } from 'lodash';

import { Icon } from '@mdi/react';
import {
  mdiMonitorDashboard,
  mdiBadgeAccountHorizontalOutline,
  mdiHomeAccount,
  mdiAirplaneLanding,
  mdiAirplaneTakeoff,
  mdiChartTimeline,
  mdiFileTree,
  mdiBedKingOutline,
  mdiCurrencyUsd,
  mdiCalendarCheck,
  mdiCashRegister,
  mdiMoonWaningCrescent,
  mdiHistory,
  mdiFileDocumentMultipleOutline,
  mdiCog,
  mdiAccountSwitchOutline,
  mdiPuzzleOutline,
  mdiOfficeBuilding,
  mdiContentCopy,
  mdiCardAccountDetailsOutline,
  mdiAccountBox,
  mdiDownload,
  mdiAccountClock,
  mdiReceipt,
  mdiChartLineVariant,
} from '@mdi/js';
// Placeholder constant for local service download URL
import { mdiCalendarEnd } from '@mdi/js';
import { mdiRobotOutline } from '@mdi/js';
import { mdiCheckDecagram } from '@mdi/js';
import { mdiCashMultiple, mdiCashFast } from '@mdi/js';
import { mdiNotebookOutline } from '@mdi/js';
import { mdiClose, mdiMenu } from '@mdi/js';
import { mdiCashRefund } from '@mdi/js';
import { mdiViewGrid } from '@mdi/js';
import { Search } from 'lucide-react';

import { useMessage } from 'util/messageLocalHook';
import { useIntl } from 'react-intl';
import permissionVerify from 'util/permissionVerify';
import CloseShiftModal from 'routes/main/report/closeshift';
import { useScreenSize } from '@/hooks/useScreenSize';

const SubMenu = Menu.SubMenu;

const SidebarTooltipDisabledContext = React.createContext(false);

/**
 * iPad Safari treats hover tooltips as an interaction, so the first tap can be
 * consumed by the tooltip instead of activating the menu link. Do not mount an
 * Ant Design tooltip while the sidebar is being used as a touch drawer.
 */
const Tooltip: React.FC<React.ComponentProps<typeof AntdTooltip>> = ({ children, ...props }) => {
  const disabled = React.useContext(SidebarTooltipDisabledContext);

  if (disabled) {
    return <>{children}</>;
  }

  return <AntdTooltip {...props}>{children}</AntdTooltip>;
};

const SidebarContent = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { t } = useMessage();
  const intl = useIntl();
  const [isCloseShiftModalVisible, setIsCloseShiftModalVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const { checkSessionResult } = useSelector((state: AppState) => state.auth as any);

  const { isDesktop } = useScreenSize();

  const checkSessionAndNavigate = (targetPath: string) => {
    // Dispatch checkSession action - saga will handle everything
    dispatch(checkSession(targetPath));
  };

  // Listen for checkSessionSuccess
  useEffect(() => {
    if (checkSessionResult) {
      const { valid, navigatePath } = checkSessionResult;
      if (valid && navigatePath) {
        history.push(navigatePath);
        closeMobileMenu();
      }
      // Reset checkSessionResult after handling
      // (you might want to add a reset action, but for now Modal is handled globally)
    }
  }, [checkSessionResult, history]);

  const showReportModal = () => {
    const title = t('app.global.label.ComingSoon');
    const content = t('app.global.label.ThisReportIsCurrentlyUnderDevelopmentPleaseCheckBackLater');
    const okText = t('app.global.bt.ok');
    Modal.info({
      title,
      content,
      okText,
    });
  };

  const handleReadCardClick = async () => {
    try {
      const accessToken = localStorage.getItem('access_token');
      const url = 'https://localhost:7190/api/KeyCard/readKeyCard';

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json; charset=utf-8',
          Authorization: `Bearer ${accessToken}`,
        },
      });

      const resultText = await response.text();
      let result;

      try {
        result = JSON.parse(resultText);
      } catch (parseError) {
        Modal.error({
          title: t('app.global.label.ResponseFormatError'),
          content: t('app.global.label.FailedToParseJSONResponse', { resultText }),
        });
        return;
      }

      if (!response.ok || result?.errorCode === 500) {
        const resultMessage =
          result?.message || `Status ${response.status}: ${response.statusText}`;
        Modal.error({
          title: t('app.global.label.Error'),
          content: t('app.global.label.AnErrorOccurred', { resultMessage }),
        });
        return;
      }

      Modal.info({
        title: t('app.global.label.KeycardData'),
        width: 600,
        content: (
          <iframe
            srcDoc={`<pre>${JSON.stringify(result, null, 2)}</pre>`}
            style={{ width: '100%', height: '400px', border: 'none' }}
          />
        ),
        okText: 'Close',
      });
    } catch (error: any) {
      const errorMessage = error?.message || error;
      Modal.error({
        title: t('app.global.label.Exception'),
        content: t('app.global.label.FailedToReadKeycard', { errorMessage }),
      });
    }
  };
  // Helper to extract filename from Content-Disposition header
  function getFilenameFromDisposition(header: string | undefined): string | undefined {
    if (!header) return undefined;

    const utf8Match = header.match(/filename\*\s*=\s*UTF-8''([^;\n]*)/i);
    if (utf8Match && utf8Match[1]) {
      return decodeURIComponent(utf8Match[1].trim());
    }

    const asciiMatch = header.match(/filename\s*=\s*["']?([^";\n]+)["']?/i);
    if (asciiMatch && asciiMatch[1]) {
      return asciiMatch[1].trim();
    }

    return undefined;
  }
  const filenameMap: Record<string, string> = {
    Immigration: 'Immigration',
    HotelRegister: 'HotelRegister',
  };

  const exportData = async (code: keyof typeof filenameMap) => {
    try {
      const accessToken = localStorage.getItem('access_token') || '';
      const headers: HeadersInit = {
        'x-api-key': API_PMS_HEADERS.headers['x-api-key'] ?? '',
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        // 👉 Optional: แสดงว่าเราจะเข้าถึง Content-Disposition
        'Access-Control-Request-Headers': 'Content-Disposition',
      };

      const endpoint = `${API_URL_V1}pms/dataExport/${code}/export`;

      const response = await fetch(endpoint, {
        method: 'POST',
        headers,
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        const errText = await response.text().catch(() => '');
        console.error('❌ Export error response:', errText);
        const resultMessage = errText || `Status ${response.status}: ${response.statusText}`;
        Modal.error({
          title: t('app.global.label.ExportError'),
          content: t('app.global.label.AnErrorOccurred', { resultMessage }),
        });
        return;
      }

      const blob = await response.blob();
      const contentDisposition = Array.from(response.headers.entries()).find(
        ([key]) => key.toLowerCase() === 'content-disposition'
      )?.[1];

      const filename = (() => {
        if (!contentDisposition) return `${filenameMap[code]}.xlsx`;

        const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;\n]*)/i);
        if (utf8Match && utf8Match[1]) return decodeURIComponent(utf8Match[1].trim());

        const asciiMatch = contentDisposition.match(/filename\s*=\s*["']?([^";\n]+)["']?/i);
        if (asciiMatch && asciiMatch[1]) return asciiMatch[1].trim();

        return `${filenameMap[code]}.xlsx`;
      })();

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      const successModal = Modal.success({
        title: t('app.global.label.DownloadComplete'),
        content: (
          <div>
            <p>Downloaded file:</p>
            <p style={{ fontWeight: 'bold', wordBreak: 'break-all' }}>{filename}</p>
          </div>
        ),
      });

      setTimeout(() => {
        successModal.destroy();
      }, 1500);
    } catch (error: any) {
      const resultMessage = error?.message || error;
      Modal.error({
        title: t('app.global.label.RequestFailed'),
        content: t('app.global.label.AnErrorOccurred', { resultMessage }),
      });
    }
  };

  const location = useLocation();
  const { systemConfig } = useSelector((state: AppState) => state);
  let { themeType, pathname } = useSelector((state: AppState) => state.settings);
  const DOWNLOAD_URL = systemConfig?.dataSource?.LOCAL_SERVICE_DOWNLOAD_URL ?? '';
  const DEFAULT = systemConfig?.dataSource?.DEFAULT ?? {};
  const LOCAL_SERVICE_DOWNLOAD_URL = DOWNLOAD_URL;
  const { dataSource: { interfaces: { KEYCARD = false } = {} } = {} } = systemConfig;
  const interfaces = systemConfig?.dataSource?.interfaces ?? {};
  const isRR4Enabled = interfaces?.RR4 ?? false;
  const isTM30Enabled = interfaces?.TM30 ?? false;
  /* Check pathurl have query parameter ? */
  const urlRedirect = `${location.pathname}${isEmpty(location.search) ? '' : location.search}`;
  const { width, navCollapsed } = useSelector((state: AppState) => state.common);
  const { device } = useResponsive();
  const isTabletNav = device === 'ipad';

  useEffect(() => {
    dispatch(setPathName(urlRedirect));
  }, [dispatch, urlRedirect]);

  const activeMenu = findMenuActive(urlRedirect || '/');

  const selectedKeys = isUndefined(activeMenu) || isNull(activeMenu) ? '' : activeMenu.method;
  const menuItemFontSize = { fontSize: 'small' };
  let navStyle = useSelector((state: AppState) => state.settings.navStyle);
  useEffect(() => {
    if ((width < TAB_SIZE || isTabletNav) && navStyle !== NAV_STYLE_DRAWER) {
      dispatch(onNavStyleChange(NAV_STYLE_DRAWER));
    } else if (width >= TAB_SIZE && !isTabletNav && navStyle === NAV_STYLE_DRAWER) {
      dispatch(onNavStyleChange(NAV_STYLE_FIXED));
    }
  }, [width, navStyle, dispatch, isTabletNav]);

  const disableSidebarTooltips =
    width < TAB_SIZE || isTabletNav || navStyle === NAV_STYLE_DRAWER;

  // Debug: log changes and close menu on mobile
  const closeMobileMenu = (info?: any) => {
    // clickable item info from antd Menu will be passed here
    // Useful for tracing which item triggered the close
    if (navStyle === NAV_STYLE_DRAWER || width < TAB_SIZE || isTabletNav) {
      // In Drawer/mobile mode, close the sidebar after a click
      dispatch(toggleCollapsedSideNav(false));
    }
  };

  // Navigate to /main/identity (used for onClick instead of <Link>)
  const goToIdentity = () => {
    history.push('/main/identity');
    closeMobileMenu();
  };

  // Extra debug to verify responsive switching
  useEffect(() => {}, [width, navStyle]);

  // Debug current route changes
  useEffect(() => {}, [urlRedirect]);

  const handleToggleSidebar = () => {
    const next = !navCollapsed;
    dispatch(toggleCollapsedSideNav(next));
  };

  // === Collapsed (mini) tooltip helpers ===
  const isCollapsed = navStyle === NAV_STYLE_MINI_SIDEBAR;
  const subItemPaddingLeft = isCollapsed ? 24 : 40;
  const collapseTitle = (iconPath: string, labelId: string) => (
    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <Icon path={iconPath} size={0.9} />
      <span>
        <IntlMessages id={labelId} />
      </span>
    </span>
  );

  // Tooltip that only shows when text is truncated via ellipsis
  const EllipsisTooltip: React.FC<{
    title: React.ReactNode;
    children: React.ReactElement<HTMLSpanElement>;
  }> = ({ title, children }) => {
    const [show, setShow] = useState(false);
    const spanRef = React.useRef<HTMLSpanElement>(null);

    useEffect(() => {
      const el = spanRef.current;
      if (!el) return;
      const check = () => setShow(el.scrollWidth > el.clientWidth);
      check();
      window.addEventListener('resize', check);
      return () => window.removeEventListener('resize', check);
    }, []);

    const clonedElement = React.cloneElement(
      children as any,
      { ref: spanRef } as any
    ) as React.ReactElement;

    return (
      <Tooltip
        title={show ? title : undefined}
        classNames={{ root: 'allow-tooltip' }}
        placement='right'
      >
        {clonedElement}
      </Tooltip>
    );
  };

  return (
    <SidebarTooltipDisabledContext.Provider value={disableSidebarTooltips}>
      <SidebarLogo />
      <div
        className='gx-sidebar-content pb-2'
        style={{
          paddingBottom: '20px',
          position: 'relative',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        {(navStyle === NAV_STYLE_DRAWER || width < TAB_SIZE) && !navCollapsed && (
          <button
            aria-label='Open sidebar'
            onClick={() => dispatch(toggleCollapsedSideNav(true))}
            className='gx-sidebar-toggle-btn gx-sidebar-toggle-open'
            style={{
              position: 'fixed',
              top: 8,
              left: 8,
              zIndex: 1200,
              border: 'none',
              background: 'rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(10px)',
              borderRadius: '8px',
              cursor: 'pointer',
              padding: '10px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              willChange: 'transform, background-color',
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.2)';
              e.currentTarget.style.transform = 'scale(1.1)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'rgba(255, 255, 255, 0.1)';
              e.currentTarget.style.transform = 'scale(1)';
            }}
          >
            <Icon path={mdiMenu} size={1.2} style={{ color: '#ffffff' }} />
          </button>
        )}
        {/* ── Search bar — visible when not collapsed ── */}
        {!isCollapsed && (
          <div className='px-3 pt-2 pb-1'>
            <div className='relative'>
              <Search
                className='absolute left-2.5 top-1/2 -translate-y-1/2 w-3.5 h-3.5 pointer-events-none'
                style={{ color: searchQuery ? 'rgba(255,255,255,0.6)' : 'rgba(255,255,255,0.35)' }}
              />
              <input
                type='text'
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder={intl.formatMessage({
                  id: 'app.global.label.searchMenu',
                  defaultMessage: 'Search menu...',
                })}
                className='w-full pl-8 pr-7 py-1.5 rounded-md text-[12px] text-white placeholder-white/30 focus:outline-none transition-all duration-200'
                style={{
                  backgroundColor: searchQuery
                    ? 'rgba(255,255,255,0.10)'
                    : 'rgba(255,255,255,0.06)',
                  border: searchQuery
                    ? '1px solid rgba(255,255,255,0.25)'
                    : '1px solid rgba(255,255,255,0.1)',
                  caretColor: '#ffffff',
                }}
                onFocus={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.10)';
                  e.currentTarget.style.borderColor = 'rgba(255,255,255,0.2)';
                }}
                onBlur={(e) => {
                  if (!searchQuery) {
                    e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.06)';
                    e.currentTarget.style.borderColor = 'rgba(255,255,255,0.1)';
                  }
                }}
              />
              {searchQuery && (
                <button
                  onClick={() => setSearchQuery('')}
                  className='absolute right-2 top-1/2 -translate-y-1/2 w-4 h-4 flex items-center justify-center rounded-full hover:bg-white/10 transition-colors'
                  style={{ color: 'rgba(255,255,255,0.5)' }}
                >
                  <span style={{ fontSize: 10, lineHeight: 1 }}>✕</span>
                </button>
              )}
            </div>
          </div>
        )}

        {/* ── Search results overlay ── */}
        {!isCollapsed &&
          searchQuery.trim() &&
          (() => {
            const q = searchQuery.trim().toLowerCase();
            const ITEMS = [
              // ── Top-level ──
              {
                key: 'dashboard',
                labelId: 'sidebar.menu.dashboard',
                label: 'Dashboard',
                path: '/main/dashboard',
                permission: null,
                parentId: null,
              },
              {
                key: 'reservations',
                labelId: 'sidebar.menu.reservations',
                label: 'Reservations',
                path: '/main/reservations',
                permission: '10000',
                parentId: null,
              },
              {
                key: 'guestIndividual',
                labelId: 'sidebar.menu.guestInhouse',
                label: 'Guest In House',
                path: '/main/guestinhouse',
                permission: '20000',
                parentId: null,
              },
              {
                key: 'expectedArrival',
                labelId: 'sidebar.menu.expectedArrival',
                label: 'Expected Arrival',
                path: '/main/expected_arrival',
                permission: '80056',
                parentId: null,
              },
              {
                key: 'expectedDeparture',
                labelId: 'sidebar.menu.expectedDeparture',
                label: 'Expected Departure',
                path: '/main/expected_departure',
                permission: '80057',
                parentId: null,
              },
              {
                key: 'roomplan',
                labelId: 'sidebar.menu.roomPlan',
                label: 'Room Planner',
                path: '/main/roomplan',
                permission: '30000',
                parentId: null,
              },
              {
                key: 'roomStatus',
                labelId: 'sidebar.menu.roomStatus',
                label: 'Room Status',
                path: '/main/registration/housekeeping',
                permission: '30000',
                parentId: null,
              },
              {
                key: 'room_avail',
                labelId: 'sidebar.menu.roomAvail',
                label: 'Room Availability',
                path: '/main/room/avail',
                permission: '30000',
                parentId: null,
              },
              {
                key: 'rate_alloment',
                labelId: 'sidebar.menu.rateAndAllotment',
                label: 'Rate Plan & Inventory',
                path: '/main/inventory',
                permission: '50000',
                parentId: null,
              },
              {
                key: 'calendar',
                labelId: 'sidebar.menu.occCalendar',
                label: 'OCC Calendar',
                path: '/main/calendar',
                permission: '30000',
                parentId: null,
              },
              {
                key: 'frontcashier',
                labelId: 'sidebar.menu.frontCashier',
                label: 'Front Cashier',
                path: '/main/frontcashier',
                permission: '40000',
                parentId: null,
              },
              {
                key: 'nightAudit',
                labelId: 'sidebar.menu.nightAudit',
                label: 'Night Audit',
                path: '/main/nightaudit',
                permission: '70000',
                parentId: null,
              },
              {
                key: 'report',
                labelId: 'sidebar.menu.reports',
                label: 'Reports',
                path: '/main/report',
                permission: null,
                parentId: null,
              },
              {
                key: 'guestHistory',
                labelId: 'sidebar.menu.guestHistory',
                label: 'Guest History',
                path: '/main/guest-history',
                permission: null,
                parentId: null,
              },
              {
                key: 'logs',
                labelId: 'sidebar.menu.logs',
                label: 'Logs',
                path: '/main/logs',
                permission: null,
                parentId: null,
              },
              {
                key: 'addon',
                labelId: 'sidebar.menu.identity.main',
                label: 'Add-Ons',
                path: '/main/addon',
                permission: null,
                parentId: null,
              },
              {
                key: 'setup',
                labelId: 'sidebar.menu.settings',
                label: 'Settings',
                path: '/main/setup',
                permission: null,
                parentId: null,
              },
              // ── Front Cashier submenu ──
              {
                key: 'cashierguest',
                labelId: 'sidebar.menu.guestFolio',
                label: 'Guest Folio',
                path: '/main/cashier/guest',
                permission: '30000',
                parentId: 'sidebar.menu.frontCashier',
                onSelect: undefined,
              },
              {
                key: 'cashierbooking',
                labelId: 'sidebar.menu.bookingFolio',
                label: 'Deposit Folio',
                path: '/main/cashier/booking',
                permission: '30000',
                parentId: 'sidebar.menu.frontCashier',
                onSelect: undefined,
              },
              {
                key: 'cashiercash',
                labelId: 'sidebar.menu.cashSales',
                label: 'Cash Sales',
                path: '/main/cashier/cash',
                permission: '33000',
                parentId: 'sidebar.menu.frontCashier',
                onSelect: undefined,
              },
              {
                key: 'cashierposting',
                labelId: 'sidebar.menu.postingJournal',
                label: 'Posting Journal',
                path: '/main/cashier/posting',
                permission: '33000',
                parentId: 'sidebar.menu.frontCashier',
                onSelect: undefined,
              },
              {
                key: 'cashiercloseshift',
                labelId: 'sidebar.menu.closeShift',
                label: 'Close Shift',
                path: null,
                permission: '33000',
                parentId: 'sidebar.menu.frontCashier',
                onSelect: () => {
                  setIsCloseShiftModalVisible(true);
                  closeMobileMenu();
                },
              },
              // ── Night Audit submenu ──
              {
                key: 'rateApprove',
                labelId: 'sidebar.menu.rateApprove',
                label: 'Rate Approve',
                path: '/main/night/approve',
                permission: '41000',
                parentId: 'sidebar.menu.nightAudit',
                onSelect: undefined,
              },
              {
                key: 'autopost',
                labelId: 'app.global.label.autoPostRoom',
                label: 'Auto Post Room',
                path: '/main/night/autopost',
                permission: '43000',
                parentId: 'sidebar.menu.nightAudit',
                onSelect: undefined,
              },
              {
                key: 'endDay',
                labelId: 'sidebar.menu.endDay',
                label: 'End of Day',
                path: '/main/night/endday',
                permission: '42000',
                parentId: 'sidebar.menu.nightAudit',
                onSelect: undefined,
              },
            ];
            const filtered = ITEMS.filter((item) => {
              const translatedLabel = intl
                .formatMessage({ id: item.labelId, defaultMessage: item.label })
                .toLowerCase();
              return (
                translatedLabel.includes(q) &&
                (item.permission === null || permissionVerify(item.permission))
              );
            });
            return (
              <div
                className='mx-3 mb-1 rounded-lg overflow-hidden'
                style={{
                  backgroundColor: 'rgba(0,0,0,0.25)',
                  border: '1px solid rgba(255,255,255,0.1)',
                }}
              >
                {filtered.length === 0 ? (
                  <div
                    className='px-3 py-4 text-center text-[11px]'
                    style={{ color: 'rgba(255,255,255,0.35)' }}
                  >
                    {intl.formatMessage(
                      {
                        id: 'app.global.label.noResultsFor',
                        defaultMessage: 'No results for "{query}"',
                      },
                      { query: searchQuery }
                    )}
                  </div>
                ) : (
                  filtered.map((item) => (
                    <button
                      key={item.key}
                      onClick={() => {
                        setSearchQuery('');
                        if ((item as any).onSelect) {
                          (item as any).onSelect();
                        } else if (item.path) {
                          checkSessionAndNavigate(item.path);
                        }
                      }}
                      className='w-full flex items-center gap-2.5 px-3 py-2 text-left transition-colors duration-150 group'
                      style={{
                        backgroundColor:
                          selectedKeys === item.key ? 'rgba(255,255,255,0.1)' : 'transparent',
                      }}
                      onMouseEnter={(e) =>
                        (e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.08)')
                      }
                      onMouseLeave={(e) =>
                        (e.currentTarget.style.backgroundColor =
                          selectedKeys === item.key ? 'rgba(255,255,255,0.1)' : 'transparent')
                      }
                    >
                      <Search
                        className='w-3 h-3 flex-shrink-0'
                        style={{ color: 'rgba(255,255,255,0.4)' }}
                      />
                      <span className='flex flex-col min-w-0'>
                        {item.parentId && (
                          <span
                            className='text-[10px] truncate'
                            style={{ color: 'rgba(255,255,255,0.35)', lineHeight: 1.2 }}
                          >
                            {intl.formatMessage({ id: item.parentId })} ›
                          </span>
                        )}
                        <span
                          className='text-[12px] truncate'
                          style={{
                            color: selectedKeys === item.key ? '#ffffff' : 'rgba(255,255,255,0.8)',
                            lineHeight: 1.3,
                          }}
                        >
                          {intl.formatMessage({ id: item.labelId, defaultMessage: item.label })}
                        </span>
                      </span>
                    </button>
                  ))
                )}
              </div>
            );
          })()}

        {/* Close Button moved to SidebarLogo.tsx */}
        <div
          className='gx-layout-sider-scrollbar'
          style={{
            flex: 1,
            minHeight: 0,
            overflowY: 'auto',
            overflowX: 'hidden',
          }}
        >
          <Menu
            defaultOpenKeys={['dashboard']}
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? 'light' : 'dark'}
            mode='inline'
            style={{
              fontSize: width < TAB_SIZE_MINI ? 16 : 13,
              marginTop: '15px',
              marginLeft: width < TAB_SIZE_MINI ? '0px' : isCollapsed ? '0px' : '-6px', // Adjusted for better alignment without overlap
              paddingRight: width < TAB_SIZE_MINI ? 4 : undefined,
            }}
            onClick={closeMobileMenu}
            inlineCollapsed={isCollapsed}
          >
            <Menu.Item
              title={
                isCollapsed
                  ? collapseTitle(mdiMonitorDashboard, 'sidebar.menu.dashboard')
                  : undefined
              }
              key='dashboard'
              style={menuItemFontSize}
              onClick={(e) => {
                e.domEvent.preventDefault();
                e.domEvent.stopPropagation();
                checkSessionAndNavigate('/main/dashboard');
              }}
            >
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  cursor: 'pointer',
                  minHeight: '48px',
                }}
              >
                <Icon path={mdiMonitorDashboard} size={1} />
                {navStyle !== NAV_STYLE_MINI_SIDEBAR && (
                  <span style={{ fontWeight: 600 }}>
                    <IntlMessages id='sidebar.menu.dashboard' />
                  </span>
                )}
              </span>
            </Menu.Item>
            {permissionVerify('10000') && (
              <Menu.Item
                title={
                  isCollapsed
                    ? collapseTitle(mdiBadgeAccountHorizontalOutline, 'sidebar.menu.reservations')
                    : undefined
                }
                key='reservations'
                style={menuItemFontSize}
              >
                {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                  <Tooltip
                    title={<IntlMessages id='sidebar.menu.reservations' />}
                    classNames={{ root: 'sidebar-tooltip' }}
                    placement='right'
                  >
                    <Link to={'/main/reservations'}>
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                          minHeight: '48px',
                        }}
                      >
                        <Icon path={mdiBadgeAccountHorizontalOutline} size={1} />
                        {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                          <span style={{ fontWeight: 600 }}>
                            <IntlMessages id='sidebar.menu.reservations' />
                          </span>
                        )}
                      </span>
                    </Link>
                  </Tooltip>
                ) : (
                  <Link to={'/main/reservations'}>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        minHeight: '48px',
                      }}
                    >
                      <Icon path={mdiBadgeAccountHorizontalOutline} size={1} />
                    </span>
                  </Link>
                )}
              </Menu.Item>
            )}
            {permissionVerify('20000') && (
              <Menu.Item
                title={
                  isCollapsed
                    ? collapseTitle(mdiHomeAccount, 'sidebar.menu.guestInhouse')
                    : undefined
                }
                key='guestIndividual'
                style={menuItemFontSize}
              >
                {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                  <Tooltip
                    title={<IntlMessages id='sidebar.menu.guestInhouse' />}
                    classNames={{ root: 'sidebar-tooltip' }}
                    placement='right'
                  >
                    <Link to='/main/guestinhouse'>
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                          minHeight: '48px',
                        }}
                      >
                        <Icon path={mdiHomeAccount} size={1} />
                        {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                          <span style={{ fontWeight: 600 }}>
                            <IntlMessages id='sidebar.menu.guestInhouse' />
                          </span>
                        )}
                      </span>
                    </Link>
                  </Tooltip>
                ) : (
                  <Link to='/main/guestinhouse'>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        minHeight: '48px',
                      }}
                    >
                      <Icon path={mdiHomeAccount} size={1} />
                    </span>
                  </Link>
                )}
              </Menu.Item>
            )}
            {permissionVerify('80056') && (
              <Menu.Item
                title={
                  isCollapsed
                    ? collapseTitle(mdiAirplaneLanding, 'sidebar.menu.expectedArrival')
                    : undefined
                }
                key='expectedArrival'
                style={menuItemFontSize}
              >
                {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                  <Tooltip
                    title={<IntlMessages id='sidebar.menu.expectedArrival' />}
                    classNames={{ root: 'sidebar-tooltip' }}
                    placement='right'
                  >
                    <Link to='/main/expected_arrival'>
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                          minHeight: '48px',
                        }}
                      >
                        <Icon path={mdiAirplaneLanding} size={1} />
                        {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                          <span style={{ fontWeight: 600 }}>
                            <IntlMessages id='sidebar.menu.expectedArrival' />
                          </span>
                        )}
                      </span>
                    </Link>
                  </Tooltip>
                ) : (
                  <Link to='/main/expected_arrival'>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        minHeight: '48px',
                      }}
                    >
                      <Icon path={mdiAirplaneLanding} size={1} />
                    </span>
                  </Link>
                )}
              </Menu.Item>
            )}
            {permissionVerify('80058') && (
              <Menu.Item
                title={
                  isCollapsed
                    ? collapseTitle(mdiAirplaneTakeoff, 'sidebar.menu.expectedDeparture')
                    : undefined
                }
                key='expectedDeparture'
                style={menuItemFontSize}
              >
                {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                  <Tooltip
                    title={<IntlMessages id='sidebar.menu.expectedDeparture' />}
                    classNames={{ root: 'sidebar-tooltip' }}
                    placement='right'
                  >
                    <Link to='/main/expected_departure'>
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                          minHeight: '48px',
                        }}
                      >
                        <Icon path={mdiAirplaneTakeoff} size={1} />
                        {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                          <span style={{ fontWeight: 600 }}>
                            <IntlMessages id='sidebar.menu.expectedDeparture' />
                          </span>
                        )}
                      </span>
                    </Link>
                  </Tooltip>
                ) : (
                  <Link to='/main/expected_departure'>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        minHeight: '48px',
                      }}
                    >
                      <Icon path={mdiAirplaneTakeoff} size={1} />
                    </span>
                  </Link>
                )}
              </Menu.Item>
            )}
            {permissionVerify('62000') && (
              <Menu.Item
                title={
                  isCollapsed ? collapseTitle(mdiChartTimeline, 'sidebar.menu.roomPlan') : undefined
                }
                key='roomplan'
                style={menuItemFontSize}
              >
                {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                  <Tooltip
                    title={<IntlMessages id='sidebar.menu.roomPlan' />}
                    classNames={{ root: 'sidebar-tooltip' }}
                    placement='right'
                  >
                    <Link to='/main/roomplan'>
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                          minHeight: '48px',
                        }}
                      >
                        <Icon path={mdiChartTimeline} size={1} />
                        {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                          <span style={{ fontWeight: 600 }}>
                            <IntlMessages id='sidebar.menu.roomPlan' />
                          </span>
                        )}
                      </span>
                    </Link>
                  </Tooltip>
                ) : (
                  <Link to='/main/roomplan'>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        minHeight: '48px',
                      }}
                    >
                      <Icon path={mdiChartTimeline} size={1} />
                    </span>
                  </Link>
                )}
              </Menu.Item>
            )}
            {/* Floor Plan moved to Setup → System category */}
            {/* {permissionVerify("62000") &&
              <Menu.Item
                title={isCollapsed ? collapseTitle(mdiViewGrid, 'sidebar.menu.floorsPlan') : undefined}
                key="floorsPlan"
                style={menuItemFontSize}
              >
                {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                  <Tooltip title={<IntlMessages id="sidebar.menu.floorsPlan" />} classNames={{ root: "sidebar-tooltip" }} placement="right">
                    <Link to="/main/floorsPlan">
                      <span style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <Icon path={mdiViewGrid} size={0.9} />
                        {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                          <span>
                            <IntlMessages id="sidebar.menu.floorsPlan" />
                          </span>
                        )}
                      </span>
                    </Link>
                  </Tooltip>
                ) : (
                  <Link to="/main/floorsPlan">
                    <span style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <Icon path={mdiViewGrid} size={0.9} />
                    </span>
                  </Link>
                )}
              </Menu.Item>
            } */}
            {permissionVerify('50000') && (
              <Menu.Item
                title={
                  isCollapsed ? collapseTitle(mdiFileTree, 'sidebar.menu.roomStatus') : undefined
                }
                key='roomStatus'
                style={menuItemFontSize}
              >
                {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                  <Tooltip
                    title={<IntlMessages id='sidebar.menu.roomStatus' />}
                    classNames={{ root: 'sidebar-tooltip' }}
                    placement='right'
                  >
                    <Link to='/main/registration/housekeeping'>
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                          minHeight: '48px',
                        }}
                      >
                        <Icon path={mdiFileTree} size={1} />
                        {/*<span>Room Status</span>*/}
                        {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                          <span style={{ fontWeight: 600 }}>
                            <IntlMessages id='sidebar.menu.roomStatus' />
                          </span>
                        )}
                      </span>
                    </Link>
                  </Tooltip>
                ) : (
                  <Link to='/main/registration/housekeeping'>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        minHeight: '48px',
                      }}
                    >
                      <Icon path={mdiFileTree} size={1} />
                    </span>
                  </Link>
                )}
              </Menu.Item>
            )}
            {permissionVerify('63000') && (
              <Menu.Item
                title={
                  isCollapsed
                    ? collapseTitle(mdiBedKingOutline, 'sidebar.menu.roomAvail')
                    : undefined
                }
                key='room_avail'
                style={menuItemFontSize}
              >
                {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                  <Tooltip
                    title={<IntlMessages id='sidebar.menu.roomAvail' />}
                    classNames={{ root: 'sidebar-tooltip' }}
                    placement='right'
                  >
                    <Link to='/main/room/avail'>
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                          minHeight: '48px',
                        }}
                      >
                        <Icon path={mdiBedKingOutline} size={1} />
                        {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                          <span style={{ fontWeight: 600 }}>
                            <IntlMessages id='sidebar.menu.roomAvail' />
                          </span>
                        )}
                      </span>
                    </Link>
                  </Tooltip>
                ) : (
                  <Link to='/main/room/avail'>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        minHeight: '48px',
                      }}
                    >
                      <Icon path={mdiBedKingOutline} size={1} />
                    </span>
                  </Link>
                )}
              </Menu.Item>
            )}
            {/* Show only on desktop screen */}
            {permissionVerify('64000') && (
              <Menu.Item
                title={
                  isCollapsed
                    ? collapseTitle(mdiCurrencyUsd, 'sidebar.menu.rateAndAllotment')
                    : undefined
                }
                key='rate_alloment'
                style={menuItemFontSize}
              >
                {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                  <Tooltip
                    title={<IntlMessages id='sidebar.menu.rateAndAllotment' />}
                    classNames={{ root: 'sidebar-tooltip' }}
                    placement='right'
                  >
                    <Link to='/main/inventory'>
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                          minHeight: '48px',
                        }}
                      >
                        <Icon path={mdiCurrencyUsd} size={1} />
                        {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                          <span style={{ fontWeight: 600 }}>
                            <IntlMessages id='sidebar.menu.rateAndAllotment' />
                          </span>
                        )}
                      </span>
                    </Link>
                  </Tooltip>
                ) : (
                  <Link to='/main/inventory'>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        minHeight: '48px',
                      }}
                    >
                      <Icon path={mdiCurrencyUsd} size={1} />
                    </span>
                  </Link>
                )}
              </Menu.Item>
            )}
            {permissionVerify('65000') && (
              <Menu.Item
                title={
                  isCollapsed
                    ? collapseTitle(mdiCalendarCheck, 'sidebar.menu.occCalendar')
                    : undefined
                }
                key='calendar'
                style={menuItemFontSize}
              >
                {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                  <Tooltip
                    title={<IntlMessages id='sidebar.menu.occCalendar' />}
                    classNames={{ root: 'sidebar-tooltip' }}
                    placement='right'
                  >
                    <Link to={'/main/calendar'}>
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                          minHeight: '48px',
                        }}
                      >
                        <Icon path={mdiCalendarCheck} size={1} />
                        {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                          <span style={{ fontWeight: 600 }}>
                            <IntlMessages id='sidebar.menu.occCalendar' />
                          </span>
                        )}
                      </span>
                    </Link>
                  </Tooltip>
                ) : (
                  <Link to={'/main/calendar'}>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        minHeight: '48px',
                      }}
                    >
                      <Icon path={mdiCalendarCheck} size={1} />
                    </span>
                  </Link>
                )}
              </Menu.Item>
            )}
            <SubMenu
              key='sub3'
              title={
                <span
                  style={{ display: 'flex', alignItems: 'center', gap: '16px', minHeight: '48px' }}
                >
                  <Icon path={mdiCashRegister} size={1} />
                  {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                    <span style={{ fontWeight: 600 }}>
                      <IntlMessages id='sidebar.menu.frontCashier' />
                    </span>
                  )}
                </span>
              }
            >
              <>
                {permissionVerify('30000') && (
                  <>
                    <Menu.Item
                      style={{
                        ...menuItemFontSize,
                        paddingLeft: subItemPaddingLeft,
                        paddingRight: 0,
                      }}
                      key='cashierguest'
                    >
                      {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                        <Tooltip
                          title={<IntlMessages id='sidebar.menu.guestFolio' />}
                          classNames={{ root: 'sidebar-tooltip' }}
                        >
                          <Link to='/main/cashier/guest'>
                            <span
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '16px',
                                minHeight: '48px',
                              }}
                            >
                              <Icon path={mdiAccountBox} size={1} />
                              {navStyle !== NAV_STYLE_MINI_SIDEBAR && (
                                <span
                                  style={{
                                    maxWidth: '130px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 600,
                                  }}
                                >
                                  <IntlMessages id='sidebar.menu.guestFolio' />
                                </span>
                              )}
                            </span>
                          </Link>
                        </Tooltip>
                      ) : (
                        <Link to='/main/cashier/guest'>
                          <span
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '16px',
                              minHeight: '48px',
                            }}
                          >
                            <Icon path={mdiAccountBox} size={1} />
                            <Tooltip title={<IntlMessages id='sidebar.menu.guestFolio' />}>
                              <span
                                style={{
                                  maxWidth: '130px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  fontWeight: 600,
                                }}
                              >
                                <IntlMessages id='sidebar.menu.guestFolio' />
                              </span>
                            </Tooltip>
                          </span>
                        </Link>
                      )}
                    </Menu.Item>
                    <Menu.Item
                      style={{
                        ...menuItemFontSize,
                        paddingLeft: subItemPaddingLeft,
                        paddingRight: 0,
                      }}
                      key='cashierbooking'
                    >
                      {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                        <Tooltip
                          title={<IntlMessages id='sidebar.menu.bookingFolio' />}
                          classNames={{ root: 'sidebar-tooltip' }}
                        >
                          <Link to='/main/cashier/booking'>
                            <span
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '16px',
                                minHeight: '48px',
                              }}
                            >
                              <Icon path={mdiCashMultiple} size={1} />
                              {navStyle !== NAV_STYLE_MINI_SIDEBAR && (
                                <span
                                  style={{
                                    maxWidth: '130px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 600,
                                  }}
                                >
                                  <IntlMessages id='sidebar.menu.bookingFolio' />
                                </span>
                              )}
                            </span>
                          </Link>
                        </Tooltip>
                      ) : (
                        <Link to='/main/cashier/booking'>
                          <span
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '16px',
                              minHeight: '48px',
                            }}
                          >
                            <Icon path={mdiCashMultiple} size={1} />
                            <Tooltip title={<IntlMessages id='sidebar.menu.bookingFolio' />}>
                              <span
                                style={{
                                  maxWidth: '130px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  fontWeight: 600,
                                }}
                              >
                                <IntlMessages id='sidebar.menu.bookingFolio' />
                              </span>
                            </Tooltip>
                          </span>
                        </Link>
                      )}
                    </Menu.Item>
                    <Menu.Item
                      style={{
                        ...menuItemFontSize,
                        paddingLeft: subItemPaddingLeft,
                        paddingRight: 0,
                      }}
                      key='cashiercash'
                    >
                      {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                        <Tooltip
                          title={<IntlMessages id='sidebar.menu.cashSales' />}
                          classNames={{ root: 'sidebar-tooltip' }}
                        >
                          <Link to='/main/cashier/cash'>
                            <span
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '16px',
                                minHeight: '48px',
                              }}
                            >
                              <Icon path={mdiCashFast} size={1} />
                              {navStyle !== NAV_STYLE_MINI_SIDEBAR && (
                                <span
                                  style={{
                                    maxWidth: '130px',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    fontWeight: 600,
                                  }}
                                >
                                  <IntlMessages id='sidebar.menu.cashSales' />
                                </span>
                              )}
                            </span>
                          </Link>
                        </Tooltip>
                      ) : (
                        <Link to='/main/cashier/cash'>
                          <span
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '16px',
                              minHeight: '48px',
                            }}
                          >
                            <Icon path={mdiCashFast} size={1} />
                            <Tooltip title={<IntlMessages id='sidebar.menu.cashSales' />}>
                              <span
                                style={{
                                  maxWidth: '130px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  fontWeight: 600,
                                }}
                              >
                                <IntlMessages id='sidebar.menu.cashSales' />
                              </span>
                            </Tooltip>
                          </span>
                        </Link>
                      )}
                    </Menu.Item>
                  </>
                )}
                {permissionVerify('33000') && (
                  <Menu.Item
                    style={{
                      ...menuItemFontSize,
                      paddingLeft: subItemPaddingLeft,
                      paddingRight: 0,
                    }}
                    key='cashierposting'
                  >
                    {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                      <Tooltip
                        title={<IntlMessages id='sidebar.menu.postingJournal' />}
                        classNames={{ root: 'sidebar-tooltip' }}
                      >
                        <Link to='/main/cashier/posting'>
                          <span
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '16px',
                              minHeight: '48px',
                            }}
                          >
                            <Icon path={mdiNotebookOutline} size={1} />
                            {navStyle !== NAV_STYLE_MINI_SIDEBAR && (
                              <span
                                style={{
                                  maxWidth: '130px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  fontWeight: 600,
                                }}
                              >
                                <IntlMessages id='sidebar.menu.postingJournal' />
                              </span>
                            )}
                          </span>
                        </Link>
                      </Tooltip>
                    ) : (
                      <Link to='/main/cashier/posting'>
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                            minHeight: '48px',
                          }}
                        >
                          <Icon path={mdiNotebookOutline} size={1} />
                          <Tooltip title={<IntlMessages id='sidebar.menu.postingJournal' />}>
                            <span
                              style={{
                                maxWidth: '130px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                fontWeight: 600,
                              }}
                            >
                              <IntlMessages id='sidebar.menu.postingJournal' />
                            </span>
                          </Tooltip>
                        </span>
                      </Link>
                    )}
                  </Menu.Item>
                )}
                {permissionVerify('33000') && (
                  <Menu.Item
                    style={{
                      ...menuItemFontSize,
                      paddingLeft: subItemPaddingLeft,
                      paddingRight: 0,
                    }}
                    key='cashiercloseshift'
                  >
                    {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                      <Tooltip
                        title={<IntlMessages id='sidebar.menu.closeShift' />}
                        classNames={{ root: 'sidebar-tooltip' }}
                      >
                        <div
                          onClick={() => {
                            setIsCloseShiftModalVisible(true);
                            closeMobileMenu();
                          }}
                        >
                          <span
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '16px',
                              cursor: 'pointer',
                              minHeight: '48px',
                            }}
                          >
                            <Icon path={mdiCashRefund} size={1} />
                            {navStyle !== NAV_STYLE_MINI_SIDEBAR && (
                              <span
                                style={{
                                  maxWidth: '130px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  fontWeight: 600,
                                }}
                              >
                                <IntlMessages id='sidebar.menu.closeShift' />
                              </span>
                            )}
                          </span>
                        </div>
                      </Tooltip>
                    ) : (
                      <div
                        onClick={() => {
                          setIsCloseShiftModalVisible(true);
                          closeMobileMenu();
                        }}
                      >
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                            cursor: 'pointer',
                            minHeight: '48px',
                          }}
                        >
                          <Icon path={mdiCashRefund} size={1} />
                          <Tooltip title={<IntlMessages id='sidebar.menu.closeShift' />}>
                            <span
                              style={{
                                maxWidth: '130px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                fontWeight: 600,
                              }}
                            >
                              <IntlMessages id='sidebar.menu.closeShift' />
                            </span>
                          </Tooltip>
                        </span>
                      </div>
                    )}
                  </Menu.Item>
                )}
              </>
            </SubMenu>

            <SubMenu
              key='nightAudit'
              title={
                <span
                  style={{ display: 'flex', alignItems: 'center', gap: '16px', minHeight: '48px' }}
                >
                  <Icon path={mdiMoonWaningCrescent} size={1} />
                  {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                    <span style={{ fontWeight: 600 }}>
                      <IntlMessages id='sidebar.menu.nightAudit' />
                    </span>
                  )}
                </span>
              }
            >
              <>
                {permissionVerify('41000') && (
                  <Menu.Item
                    style={{
                      ...menuItemFontSize,
                      paddingLeft: subItemPaddingLeft,
                      paddingRight: 0,
                    }}
                    key='rateApprove'
                  >
                    {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                      <Tooltip
                        title={<IntlMessages id='sidebar.menu.rateApprove' />}
                        classNames={{ root: 'sidebar-tooltip' }}
                      >
                        <Link to='/main/night/approve'>
                          <span
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '16px',
                              minHeight: '48px',
                            }}
                          >
                            <Icon path={mdiCheckDecagram} size={1} />
                            {navStyle !== NAV_STYLE_MINI_SIDEBAR && (
                              <span
                                style={{
                                  maxWidth: '130px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  fontWeight: 600,
                                }}
                              >
                                <IntlMessages id='sidebar.menu.rateApprove' />
                              </span>
                            )}
                          </span>
                        </Link>
                      </Tooltip>
                    ) : (
                      <Link to='/main/night/approve'>
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                            minHeight: '48px',
                          }}
                        >
                          <Icon path={mdiCheckDecagram} size={1} />
                          <Tooltip title={<IntlMessages id='sidebar.menu.rateApprove' />}>
                            <span
                              style={{
                                maxWidth: '130px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                fontWeight: 600,
                              }}
                            >
                              <IntlMessages id='sidebar.menu.rateApprove' />
                            </span>
                          </Tooltip>
                        </span>
                      </Link>
                    )}
                  </Menu.Item>
                )}
                {permissionVerify('43000') && (
                  <Menu.Item
                    style={{
                      ...menuItemFontSize,
                      paddingLeft: subItemPaddingLeft,
                      paddingRight: 0,
                    }}
                    key='autopost'
                  >
                    {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                      <Tooltip
                        title={<IntlMessages id='app.global.label.autoPostRoom' />}
                        classNames={{ root: 'sidebar-tooltip' }}
                      >
                        <Link to='/main/night/autopost'>
                          <span
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '16px',
                              minHeight: '48px',
                            }}
                          >
                            <Icon path={mdiRobotOutline} size={1} />
                            {navStyle !== NAV_STYLE_MINI_SIDEBAR && (
                              <span
                                style={{
                                  maxWidth: '130px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  fontWeight: 600,
                                }}
                              >
                                <IntlMessages id='app.global.label.autoPostRoom' />
                              </span>
                            )}
                          </span>
                        </Link>
                      </Tooltip>
                    ) : (
                      <Link to='/main/night/autopost'>
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                            minHeight: '48px',
                          }}
                        >
                          <Icon path={mdiRobotOutline} size={1} />
                          <Tooltip title={<IntlMessages id='app.global.label.autoPostRoom' />}>
                            <span
                              style={{
                                maxWidth: '130px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                fontWeight: 600,
                              }}
                            >
                              <IntlMessages id='app.global.label.autoPostRoom' />
                            </span>
                          </Tooltip>
                        </span>
                      </Link>
                    )}
                  </Menu.Item>
                )}
                {permissionVerify('42000') && (
                  <Menu.Item
                    style={{
                      ...menuItemFontSize,
                      paddingLeft: subItemPaddingLeft,
                      paddingRight: 0,
                    }}
                    key='endDay'
                  >
                    {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                      <Tooltip
                        title={<IntlMessages id='sidebar.menu.endDay' />}
                        classNames={{ root: 'sidebar-tooltip' }}
                      >
                        <Link to='/main/night/endday'>
                          <span
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '16px',
                              minHeight: '48px',
                            }}
                          >
                            <Icon path={mdiCalendarEnd} size={1} />
                            {navStyle !== NAV_STYLE_MINI_SIDEBAR && (
                              <span
                                style={{
                                  maxWidth: '130px',
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  fontWeight: 600,
                                }}
                              >
                                <IntlMessages id='sidebar.menu.endDay' />
                              </span>
                            )}
                          </span>
                        </Link>
                      </Tooltip>
                    ) : (
                      <Link to='/main/night/endday'>
                        <span
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                            minHeight: '48px',
                          }}
                        >
                          <Icon path={mdiCalendarEnd} size={1} />
                          <Tooltip title={<IntlMessages id='sidebar.menu.endDay' />}>
                            <span
                              style={{
                                maxWidth: '130px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                fontWeight: 600,
                              }}
                            >
                              <IntlMessages id='sidebar.menu.endDay' />
                            </span>
                          </Tooltip>
                        </span>
                      </Link>
                    )}
                  </Menu.Item>
                )}
              </>
            </SubMenu>

            {permissionVerify('80000') && (
              <Menu.Item
                title={
                  isCollapsed
                    ? collapseTitle(mdiFileDocumentMultipleOutline, 'sidebar.menu.reports')
                    : undefined
                }
                key='report'
                style={menuItemFontSize}
              >
                {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                  <Tooltip
                    title={<IntlMessages id='sidebar.menu.reports' />}
                    classNames={{ root: 'sidebar-tooltip' }}
                    placement='right'
                  >
                    <Link to='/main/report'>
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                          minHeight: '48px',
                        }}
                      >
                        <Icon path={mdiFileDocumentMultipleOutline} size={1} />
                        {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                          <span style={{ fontWeight: 600 }}>
                            <IntlMessages id='sidebar.menu.reports' />
                          </span>
                        )}
                      </span>
                    </Link>
                  </Tooltip>
                ) : (
                  <Link to='/main/report'>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        minHeight: '48px',
                      }}
                    >
                      <Icon path={mdiFileDocumentMultipleOutline} size={1} />
                    </span>
                  </Link>
                )}
              </Menu.Item>
            )}
            <Menu.Item
              title={
                isCollapsed ? collapseTitle(mdiChartLineVariant, 'sidebar.menu.insight') : undefined
              }
              key='insight'
              style={menuItemFontSize}
            >
              {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                <Tooltip
                  title={<IntlMessages id='sidebar.menu.insight' />}
                  classNames={{ root: 'sidebar-tooltip' }}
                  placement='right'
                >
                  <Link to='/main/insight'>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        minHeight: '48px',
                      }}
                    >
                      <Icon path={mdiChartLineVariant} size={1} />
                      {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                        <span style={{ fontWeight: 600 }}>
                          <IntlMessages id='sidebar.menu.insight' />
                        </span>
                      )}
                    </span>
                  </Link>
                </Tooltip>
              ) : (
                <Link to='/main/insight'>
                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px',
                      minHeight: '48px',
                    }}
                  >
                    <Icon path={mdiChartLineVariant} size={1} />
                  </span>
                </Link>
              )}
            </Menu.Item>

            {permissionVerify('66000') && (
              <Menu.Item
                title={
                  isCollapsed
                    ? collapseTitle(mdiAccountClock, 'sidebar.menu.guestHistory')
                    : undefined
                }
                key='guestHistory'
                style={menuItemFontSize}
              >
                {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                  <Tooltip
                    title={<IntlMessages id='sidebar.menu.guestHistory' />}
                    classNames={{ root: 'sidebar-tooltip' }}
                    placement='right'
                  >
                    <Link to='/main/guest-history'>
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                          minHeight: '48px',
                        }}
                      >
                        <Icon path={mdiAccountClock} size={1} />
                        {navStyle !== NAV_STYLE_MINI_SIDEBAR && (
                          <span style={{ fontWeight: 600 }}>
                            <IntlMessages id='sidebar.menu.guestHistory' />
                          </span>
                        )}
                      </span>
                    </Link>
                  </Tooltip>
                ) : (
                  <Link to='/main/guest-history'>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        minHeight: '48px',
                      }}
                    >
                      <Icon path={mdiAccountClock} size={1} />
                    </span>
                  </Link>
                )}
              </Menu.Item>
            )}

            {/* <Menu.Item
              title={isCollapsed ? collapseTitle(mdiReceipt, 'sidebar.menu.taxInvoice') : undefined}
              key="taxInvoice"
              style={menuItemFontSize}
            >
              {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                <Tooltip title={<IntlMessages id="sidebar.menu.taxInvoice" />} classNames={{ root: "sidebar-tooltip" }} placement="right">
                  <Link to="/main/tax-invoice">
                    <span style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                      <Icon path={mdiReceipt} size={0.9} />
                      {navStyle !== NAV_STYLE_MINI_SIDEBAR && (
                        <span>
                          <IntlMessages id="sidebar.menu.taxInvoice" />
                        </span>
                      )}
                    </span>
                  </Link>
                </Tooltip>
              ) : (
                <Link to="/main/tax-invoice">
                  <span style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <Icon path={mdiReceipt} size={0.9} />
                  </span>
                </Link>
              )}
            </Menu.Item> */}

            {permissionVerify('67000') && (
              <Menu.Item
                title={isCollapsed ? collapseTitle(mdiHistory, 'sidebar.menu.logs') : undefined}
                key='logs'
                style={menuItemFontSize}
              >
                {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                  <Tooltip
                    title={<IntlMessages id='sidebar.menu.logs' />}
                    classNames={{ root: 'sidebar-tooltip' }}
                    placement='right'
                  >
                    <Link to='/main/logs'>
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                          minHeight: '48px',
                        }}
                      >
                        <Icon path={mdiHistory} size={1} />
                        {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                          <span style={{ fontWeight: 600 }}>
                            <IntlMessages id='sidebar.menu.logs' />
                          </span>
                        )}
                      </span>
                    </Link>
                  </Tooltip>
                ) : (
                  <Link to='/main/logs'>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        minHeight: '48px',
                      }}
                    >
                      <Icon path={mdiHistory} size={1} />
                    </span>
                  </Link>
                )}
              </Menu.Item>
            )}

            <Menu.Item
              title={
                isCollapsed
                  ? collapseTitle(mdiPuzzleOutline, 'sidebar.menu.identity.main')
                  : undefined
              }
              key='addon'
              style={menuItemFontSize}
            >
              {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                <Tooltip
                  title={<IntlMessages id='sidebar.menu.identity.main' />}
                  classNames={{ root: 'sidebar-tooltip' }}
                  placement='right'
                >
                  <Link to='/main/addon'>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        minHeight: '48px',
                      }}
                    >
                      <Icon path={mdiPuzzleOutline} size={1} />
                      {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                        <span style={{ fontWeight: 600 }}>
                          <IntlMessages id='sidebar.menu.identity.main' />
                        </span>
                      )}
                    </span>
                  </Link>
                </Tooltip>
              ) : (
                <Link to='/main/addon'>
                  <span
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '16px',
                      minHeight: '48px',
                    }}
                  >
                    <Icon path={mdiPuzzleOutline} size={1} />
                  </span>
                </Link>
              )}
            </Menu.Item>
            {permissionVerify('90000') && (
              <Menu.Item
                title={isCollapsed ? collapseTitle(mdiCog, 'sidebar.menu.settings') : undefined}
                key='setup'
                style={menuItemFontSize}
              >
                {navStyle !== NAV_STYLE_MINI_SIDEBAR ? (
                  <Tooltip
                    title={<IntlMessages id='sidebar.menu.settings' />}
                    classNames={{ root: 'sidebar-tooltip' }}
                    placement='right'
                  >
                    <Link to='/main/setup'>
                      <span
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '16px',
                          minHeight: '48px',
                        }}
                      >
                        <Icon path={mdiCog} size={1} />
                        {!(navStyle === NAV_STYLE_MINI_SIDEBAR) && (
                          <span style={{ fontWeight: 600 }}>
                            <IntlMessages id='sidebar.menu.settings' />
                          </span>
                        )}
                      </span>
                    </Link>
                  </Tooltip>
                ) : (
                  <Link to='/main/setup'>
                    <span
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '16px',
                        minHeight: '48px',
                      }}
                    >
                      <Icon path={mdiCog} size={1} />
                    </span>
                  </Link>
                )}
              </Menu.Item>
            )}
          </Menu>
        </div>

        {/* No bottom profile section - removed per design spec */}
      </div>
      <style>{`
        /* CRITICAL: Override #038fdd color with highest specificity - Target exact selectors from Ant Design */
        /* This must come first to override: .ant-menu-dark .ant-menu-item > span > a */
        .gx-app-sidebar.ant-layout-sider .ant-menu-dark .ant-menu-item,
        .gx-app-sidebar.ant-layout-sider .ant-menu-dark .ant-menu-item-group-title,
        .gx-app-sidebar.ant-layout-sider .ant-menu-dark .ant-menu-item > a,
        .gx-app-sidebar.ant-layout-sider .ant-menu-dark .ant-menu-item > span > a,
        .gx-app-sidebar.ant-layout-sider .ant-menu-dark .ant-menu-item > span,
        .gx-app-sidebar.ant-layout-sider .ant-menu-dark .ant-menu-item > span > span,
        .gx-app-sidebar.ant-layout-sider .ant-menu-dark .ant-menu-submenu-title,
        .gx-app-sidebar.ant-layout-sider .ant-menu-dark .ant-menu-submenu-title > a,
        .gx-app-sidebar.ant-layout-sider .ant-menu-dark .ant-menu-submenu-title > span,
        .gx-app-sidebar.ant-layout-sider .ant-menu-dark .ant-menu-submenu-title > span > span,
        .gx-app-sidebar.ant-layout-sider .ant-menu-dark .ant-menu-submenu-title > span > a,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item-group-title,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item > a,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item > span > a,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item > span,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item > span > span,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-submenu-title,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-submenu-title > a,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-submenu-title > span,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-submenu-title > span > span,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-submenu-title > span > a {
          color: #ffffff !important;
        }

        /* Enhanced sidebar menu styles - Bright white font colors - Override all Ant Design defaults */
        .gx-app-sidebar .ant-menu-dark .ant-menu-item,
        .gx-app-sidebar .ant-menu-dark .ant-menu-submenu-title,
        .gx-app-sidebar .ant-menu-dark .ant-menu-item > a,
        .gx-app-sidebar .ant-menu-dark .ant-menu-submenu-title > a,
        .gx-app-sidebar .ant-menu-dark .ant-menu-item > span > span,
        .gx-app-sidebar .ant-menu-dark .ant-menu-item > span > a,
        .gx-app-sidebar .ant-menu-dark .ant-menu-submenu-title > span > span,
        .gx-app-sidebar .ant-menu-dark .ant-menu-submenu-title > span > a,
        .gx-app-sidebar .ant-menu-dark .ant-menu-item > span,
        .gx-app-sidebar .ant-menu-dark .ant-menu-submenu-title > span,
        .gx-app-sidebar .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item,
        .gx-app-sidebar .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-submenu-title,
        .gx-app-sidebar .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item > span > span,
        .gx-app-sidebar .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item > span > a,
        .gx-app-sidebar .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-submenu-title > span > span,
        .gx-app-sidebar .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-submenu-title > span > a,
        .gx-app-sidebar .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item > a,
        .gx-app-sidebar .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-submenu-title > a {
          color: #ffffff !important;
          will-change: transform, background-color;
        }

        /* Override hover states */
        .gx-app-sidebar .ant-menu-dark .ant-menu-item:hover,
        .gx-app-sidebar .ant-menu-dark .ant-menu-item-active,
        .gx-app-sidebar .ant-menu-dark .ant-menu-submenu-title:hover,
        .gx-app-sidebar .ant-menu-dark .ant-menu-submenu-active,
        .gx-app-sidebar .ant-menu-dark .ant-menu-item:hover > a,
        .gx-app-sidebar .ant-menu-dark .ant-menu-submenu-title:hover > a {
          color: #ffffff !important;
        }

        /* Override selected state colors */
        .gx-app-sidebar .ant-menu-dark .ant-menu-item-selected,
        .gx-app-sidebar .ant-menu-dark .ant-menu-item-selected > a,
        .gx-app-sidebar .ant-menu-dark .ant-menu-item-selected > a:hover,
        .gx-app-sidebar .ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-title {
          color: #ffffff !important;
        }

        /* Submenu items */
        .gx-app-sidebar .ant-menu-dark .ant-menu-inline .ant-menu-item,
        .gx-app-sidebar .ant-menu-dark .ant-menu-inline .ant-menu-item > a,
        .gx-app-sidebar .ant-menu-dark .ant-menu-inline .ant-menu-item > span > span {
          color: #ffffff !important;
        }

        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item:hover,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-submenu-title:hover {
          background: transparent !important;
          transform: translateX(2px);
        }

        /* Text color change on hover - only text color, no background */
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item:hover > span > span,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item:hover > a,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item:hover > span > a,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-submenu-title:hover > span > span,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-submenu-title:hover > a,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-submenu-title:hover > span {
          color: rgba(255, 255, 255, 0.85) !important;
        }

        /* Selected state for all menu items - Top level and submenu */
        /* Highest specificity to ensure it works for all menu items */
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item-selected,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item.ant-menu-item-selected,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) li.ant-menu-item.ant-menu-item-selected,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) li.ant-menu-item-selected.ant-menu-item,
        /* Ensure it works for items wrapped in Link/Tooltip */
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item-selected[data-menu-id],
        .ant-menu-dark:not(.ant-menu-inline-collapsed) li.ant-menu-item-selected[data-menu-id] {
          background: rgba(255, 255, 255, 0.08) !important;
          border-left: 3px solid #ffffff !important;
          box-shadow: none !important;
          transform: translateX(0);
          transition: background 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                      border-left 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
          will-change: background, border-left;
          backface-visibility: hidden;
        }

        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item-selected > span > span,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item-selected > a,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item-selected {
          color: #ffffff !important;
          font-weight: 600 !important;
          transition: color 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                      font-weight 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }

        /* Icon colors - Bright white */
        .ant-menu-dark:not(.ant-menu-inline-collapsed) svg {
          color: #ffffff !important;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
          will-change: transform, color;
          width: 1.35rem !important;
          height: 1.35rem !important;
          min-width: 1.35rem !important;
          min-height: 1.35rem !important;
          max-width: 1.35rem !important;
          max-height: 1.35rem !important;
        }

        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item:hover svg,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-submenu-title:hover svg {
          color: #ffffff !important;
          transform: scale(1.1) translateZ(0) !important;
          filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.5));
        }

        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item-selected svg {
          color: #ffffff !important;
          filter: drop-shadow(0 0 6px rgba(255, 255, 255, 0.8));
          transform: scale(1.05) translateZ(0);
        }

        /* Submenu items - Bright white */
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-inline .ant-menu-item,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-inline .ant-menu-item > span > span,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-inline .ant-menu-item > a {
          color: #ffffff !important;
        }

        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-inline .ant-menu-item:hover {
          background: transparent !important;
          transform: translateX(4px);
        }

        /* Submenu item hover - text color only */
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-inline .ant-menu-item:hover > span > span,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-inline .ant-menu-item:hover > a,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-inline .ant-menu-item:hover > span > a {
          color: rgba(255, 255, 255, 0.85) !important;
        }

        /* Selected state for submenu items */
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-inline .ant-menu-item-selected,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-inline li.ant-menu-item.ant-menu-item-selected,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-submenu .ant-menu-inline .ant-menu-item-selected,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-submenu .ant-menu-inline li.ant-menu-item-selected {
          background: rgba(255, 255, 255, 0.08) !important;
          color: #ffffff !important;
          font-weight: 600 !important;
          box-shadow: none !important;
          border-left: 3px solid #ffffff !important;
          transition: background 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                      color 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                      border-left 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
          will-change: background, border-left;
          backface-visibility: hidden;
        }

        /* Ensure all menu items with selected class show background - Higher specificity */
        .gx-app-sidebar .ant-menu-dark .ant-menu-item-selected,
        .gx-app-sidebar .ant-menu-dark li.ant-menu-item-selected,
        .gx-app-sidebar .ant-menu-dark .ant-menu-item.ant-menu-item-selected,
        .gx-app-sidebar .ant-menu-dark li.ant-menu-item.ant-menu-item-selected,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item-selected,
        .gx-drawer-sidebar .ant-menu-dark li.ant-menu-item-selected,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item.ant-menu-item-selected,
        .gx-drawer-sidebar .ant-menu-dark li.ant-menu-item.ant-menu-item-selected {
          background: rgba(255, 255, 255, 0.08) !important;
          border-left: 3px solid #ffffff !important;
          box-shadow: none !important;
        }

        /* Force icon size to 1.35rem for all menu items - Override any container constraints */
        .ant-menu-dark .ant-menu-item svg,
        .ant-menu-dark .ant-menu-submenu-title svg,
        .ant-menu-dark .ant-menu-item .ant-menu-title-content svg,
        .ant-menu-dark .ant-menu-submenu-title .ant-menu-title-content svg,
        .ant-menu-dark .ant-menu-item span svg,
        .ant-menu-dark .ant-menu-submenu-title span svg,
        .ant-menu-dark .ant-menu-item a svg,
        .ant-menu-dark .ant-menu-submenu-title a svg {
          width: 1.35rem !important;
          height: 1.35rem !important;
          min-width: 1.35rem !important;
          min-height: 1.35rem !important;
          max-width: 1.35rem !important;
          max-height: 1.35rem !important;
          flex-shrink: 0 !important;
        }

        /* Prevent ant-menu-title-content from constraining icon size */
        .ant-menu-dark .ant-menu-title-content {
          display: flex !important;
          align-items: center !important;
        }

        .ant-menu-dark .ant-menu-title-content svg {
          flex-shrink: 0 !important;
          width: 1.35rem !important;
          height: 1.35rem !important;
        }

        /* Universal selected state - Highest priority for all menu items */
        /* Target all possible selectors to ensure selected state always shows */
        .ant-menu-dark .ant-menu-item-selected,
        .ant-menu-dark li.ant-menu-item-selected,
        .ant-menu-dark .ant-menu-item.ant-menu-item-selected,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item-selected,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) li.ant-menu-item-selected,
        .ant-menu-dark:not(.ant-menu-inline-collapsed) .ant-menu-item.ant-menu-item-selected,
        .gx-app-sidebar .ant-menu-dark .ant-menu-item-selected,
        .gx-app-sidebar .ant-menu-dark li.ant-menu-item-selected,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item-selected,
        .gx-drawer-sidebar .ant-menu-dark li.ant-menu-item-selected,
        /* Additional selectors with higher specificity */
        .gx-app-sidebar.ant-layout-sider .ant-menu-dark .ant-menu-item-selected,
        .gx-app-sidebar.ant-layout-sider .ant-menu-dark li.ant-menu-item-selected,
        .gx-app-sidebar .ant-menu-dark li.ant-menu-item.ant-menu-item-selected,
        .gx-drawer-sidebar .ant-menu-dark li.ant-menu-item.ant-menu-item-selected,
        /* Ensure background is applied even with inline styles */
        .ant-menu-dark li.ant-menu-item-selected[role="menuitem"],
        .ant-menu-dark .ant-menu-item-selected[role="menuitem"] {
          background: rgba(255, 255, 255, 0.08) !important;
          border-left: 3px solid #ffffff !important;
          box-shadow: none !important;
        }

        /* Smooth transitions with hardware acceleration */
        .ant-menu-dark .ant-menu-item,
        .ant-menu-dark .ant-menu-submenu-title,
        .ant-menu-dark .ant-menu-item > span,
        .ant-menu-dark .ant-menu-submenu-title > span {
          transition: background 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                      color 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                      border-left 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                      transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
          backface-visibility: hidden;
          perspective: 1000px;
          transform: translateZ(0);
          will-change: background, color, border-left, transform;
        }

        /* Specific transition for menu items to prevent jank */
        .ant-menu-dark .ant-menu-item {
          transition: background 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                      border-left 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                      transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }

        /* Submenu animation improvements */
        .ant-menu-dark .ant-menu-submenu .ant-menu {
          transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1),
                      transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
          will-change: opacity, transform;
        }

        .ant-menu-dark .ant-menu-submenu-open > .ant-menu-submenu-title {
          color: #ffffff !important;
        }

        /* Additional overrides to ensure all text is white - override Ant Design variables */
        .gx-app-sidebar .ant-menu-dark .ant-menu-item > a,
        .gx-app-sidebar .ant-menu-dark .ant-menu-submenu-title,
        .gx-app-sidebar .ant-menu-dark .ant-menu-item,
        .gx-app-sidebar .ant-menu-dark .ant-menu-submenu-title > span,
        .gx-app-sidebar .ant-menu-dark .ant-menu-item > span,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item > a,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-submenu-title,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-submenu-title > span,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item > span {
          color: #ffffff !important;
        }

        /* Override hover and active states */
        .gx-app-sidebar .ant-menu-dark .ant-menu-item:hover,
        .gx-app-sidebar .ant-menu-dark .ant-menu-item-active,
        .gx-app-sidebar .ant-menu-dark .ant-menu-submenu-title:hover,
        .gx-app-sidebar .ant-menu-dark .ant-menu-submenu-active,
        .gx-app-sidebar .ant-menu-dark .ant-menu-item:hover > a,
        .gx-app-sidebar .ant-menu-dark .ant-menu-submenu-title:hover > a,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item:hover,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item-active,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-submenu-title:hover,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-submenu-active,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item:hover > a,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-submenu-title:hover > a {
          color: #ffffff !important;
        }

        /* Override selected state */
        .gx-app-sidebar .ant-menu-dark .ant-menu-item-selected,
        .gx-app-sidebar .ant-menu-dark .ant-menu-item-selected > a,
        .gx-app-sidebar .ant-menu-dark .ant-menu-item-selected > a:hover,
        .gx-app-sidebar .ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-title,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item-selected,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item-selected > a,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-item-selected > a:hover,
        .gx-drawer-sidebar .ant-menu-dark .ant-menu-submenu-selected .ant-menu-submenu-title {
          color: #ffffff !important;
        }

        /* Toggle button animations */
        .gx-sidebar-toggle-btn {
          backface-visibility: hidden;
          transform: translateZ(0);
        }

        .gx-sidebar-toggle-close {
          pointer-events: auto;
        }

        /* Prevent layout shifts during animation */
        .ant-layout-sider {
          will-change: width;
          transform: translateZ(0);
        }

        /* Native Scrollbar Styles - Dark Theme Sidebar */
        /* Custom scrollbar for WebKit browsers (Chrome, Safari, Edge) */
        .gx-layout-sider-scrollbar::-webkit-scrollbar {
          width: 6px;
        }

        .gx-layout-sider-scrollbar::-webkit-scrollbar-track {
          background: transparent;
          border-radius: 3px;
        }

        .gx-layout-sider-scrollbar::-webkit-scrollbar-thumb {
          background-color: rgba(255, 255, 255, 0.3);
          border-radius: 3px;
          transition: background-color 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .gx-layout-sider-scrollbar::-webkit-scrollbar-thumb:hover {
          background-color: rgba(255, 255, 255, 0.5);
        }

        .gx-layout-sider-scrollbar::-webkit-scrollbar-thumb:active {
          background-color: rgba(255, 255, 255, 0.6);
        }

        /* Custom scrollbar for Firefox */
        .gx-layout-sider-scrollbar {
          scrollbar-width: thin;
          scrollbar-color: rgba(255, 255, 255, 0.3) transparent;
        }

        /* Show scrollbar on smaller screens (notebook) */
        @media (max-width: 1366px) {
          .gx-layout-sider-scrollbar::-webkit-scrollbar-thumb {
            background-color: rgba(255, 255, 255, 0.4);
          }

          .gx-layout-sider-scrollbar::-webkit-scrollbar-thumb:hover {
            background-color: rgba(255, 255, 255, 0.6);
          }

          .gx-layout-sider-scrollbar {
            scrollbar-color: rgba(255, 255, 255, 0.4) transparent;
          }
        }

        /* Native Scrollbar Container - Proper height calculation */
        .gx-layout-sider-scrollbar {
          height: 100% !important;
          min-height: 0 !important;
          overflow-y: auto !important;
          overflow-x: hidden !important;
          scroll-behavior: smooth !important;
          -webkit-overflow-scrolling: touch !important;
        }

        /* Adjust max-height for different screen sizes */
        @media (max-width: 1366px) {
          .gx-layout-sider-scrollbar {
            max-height: calc(100vh - 20px) !important;
          }
        }

        @media (min-width: 1367px) and (max-width: 1600px) {
          .gx-layout-sider-scrollbar {
            max-height: calc(100vh - 20px) !important;
          }
        }

        @media (min-width: 1601px) {
          .gx-layout-sider-scrollbar {
            max-height: calc(100vh - 20px) !important;
          }
        }

        /* Adjust sidebar content padding to fit more menu items */
        .gx-sidebar-content.pb-2 {
          padding-bottom: 20px !important;
        }

        /* Increase available height for menu items - add extra space for one more menu item */
        .gx-sidebar-content {
          height: calc(100% + 40px) !important; /* Add extra 40px to fit one more menu item */
        }

        /* Native scrollbar is already configured above - no additional CSS needed */

        /* Menu collapse/expand animation */
        .ant-menu-inline-collapsed {
          transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }

        /* Collapsed state styles - white icons */
        .ant-menu-dark.ant-menu-inline-collapsed .ant-menu-item svg,
        .ant-menu-dark.ant-menu-inline-collapsed .ant-menu-submenu-title svg {
          color: #ffffff !important;
          width: 1.35rem !important;
          height: 1.35rem !important;
          min-width: 1.35rem !important;
          min-height: 1.35rem !important;
          max-width: 1.35rem !important;
          max-height: 1.35rem !important;
        }

        .ant-menu-dark.ant-menu-inline-collapsed .ant-menu-item:hover svg,
        .ant-menu-dark.ant-menu-inline-collapsed .ant-menu-submenu-title:hover svg {
          color: #ffffff !important;
          transform: scale(1.15) translateZ(0);
        }

        .ant-menu-dark.ant-menu-inline-collapsed .ant-menu-item-selected svg {
          color: #ffffff !important;
          filter: drop-shadow(0 0 6px rgba(255, 255, 255, 0.8));
        }

        /* Hide background and border-left when sidebar is collapsed to prevent padding issues */
        .ant-menu-dark.ant-menu-inline-collapsed .ant-menu-item-selected,
        .ant-menu-dark.ant-menu-inline-collapsed li.ant-menu-item-selected,
        .ant-menu-dark.ant-menu-inline-collapsed .ant-menu-item.ant-menu-item-selected,
        .ant-menu-dark.ant-menu-inline-collapsed li.ant-menu-item.ant-menu-item-selected,
        .ant-menu-dark.ant-menu-inline-collapsed .ant-menu-inline .ant-menu-item-selected,
        .ant-menu-dark.ant-menu-inline-collapsed .ant-menu-inline li.ant-menu-item-selected {
          background: transparent !important;
          border-left: none !important;
          box-shadow: none !important;
        }

        /* Ensure submenu items in collapsed state also have no background/border */
        .ant-menu-dark.ant-menu-inline-collapsed .ant-menu-submenu .ant-menu-inline .ant-menu-item-selected,
        .ant-menu-dark.ant-menu-inline-collapsed .ant-menu-submenu .ant-menu-inline li.ant-menu-item-selected {
          background: transparent !important;
          border-left: none !important;
          box-shadow: none !important;
        }

        /* ═══════════════════════════════════════════════════════════════
           POPUP SUBMENU DARK THEME — fixes black submenu when collapsed
           Ant Design renders popup submenus as portals outside the sider,
           so we must target them globally here.
        ═══════════════════════════════════════════════════════════════ */
        /* Popup submenu container background */
        .ant-menu-submenu-popup > .ant-menu,
        .ant-menu-submenu-popup .ant-menu-sub,
        .ant-menu-submenu-popup .ant-menu-vertical {
          background-color: #001529 !important;
          border-radius: 8px !important;
          box-shadow: 0 6px 24px rgba(0,0,0,0.5) !important;
          padding: 4px 0 !important;
        }

        /* Popup submenu title (parent label in popup) */
        .ant-menu-submenu-popup .ant-menu-submenu-title,
        .ant-menu-submenu-popup .ant-menu-submenu-title > span,
        .ant-menu-submenu-popup .ant-menu-submenu-title .ant-menu-title-content {
          color: rgba(255,255,255,0.75) !important;
          background: transparent !important;
        }
        .ant-menu-submenu-popup .ant-menu-submenu-title:hover,
        .ant-menu-submenu-popup .ant-menu-submenu-title:hover > span {
          color: #ffffff !important;
          background: rgba(255,255,255,0.08) !important;
        }

        /* Popup submenu items */
        .ant-menu-submenu-popup .ant-menu-item,
        .ant-menu-submenu-popup .ant-menu-item > span,
        .ant-menu-submenu-popup .ant-menu-item > a,
        .ant-menu-submenu-popup .ant-menu-item .ant-menu-title-content,
        .ant-menu-submenu-popup .ant-menu-item .ant-menu-title-content > *,
        .ant-menu-submenu-popup .ant-menu-item span span {
          color: rgba(255,255,255,0.85) !important;
          background: transparent !important;
        }

        /* Popup item hover */
        .ant-menu-submenu-popup .ant-menu-item:hover,
        .ant-menu-submenu-popup .ant-menu-item-active {
          background: rgba(255,255,255,0.08) !important;
          color: #ffffff !important;
        }
        .ant-menu-submenu-popup .ant-menu-item:hover span,
        .ant-menu-submenu-popup .ant-menu-item:hover a,
        .ant-menu-submenu-popup .ant-menu-item-active span,
        .ant-menu-submenu-popup .ant-menu-item-active a {
          color: #ffffff !important;
        }

        /* Popup item selected */
        .ant-menu-submenu-popup .ant-menu-item-selected,
        .ant-menu-submenu-popup .ant-menu-item-selected > span,
        .ant-menu-submenu-popup .ant-menu-item-selected > a {
          background: rgba(255,255,255,0.12) !important;
          color: #ffffff !important;
          font-weight: 600 !important;
        }

        /* Popup SVG icons */
        .ant-menu-submenu-popup svg {
          color: #ffffff !important;
          fill: currentColor;
        }

        /* Popup submenu arrow */
        .ant-menu-submenu-popup .ant-menu-submenu-arrow::before,
        .ant-menu-submenu-popup .ant-menu-submenu-arrow::after {
          background: rgba(255,255,255,0.65) !important;
        }
        /* ═══════════════════════════════════════════════════════════════ */

        /* ═══════════════════════════════════════════════════════════════
           FIX: ANT DESIGN v5 COLLAPSED ICON VISIBILITY
           In AntD v5, inlineCollapsed applies opacity:0 + max-width:0 to
           .ant-menu-title-content. Our icons are INSIDE title-content
           (not via the icon prop), so they get hidden too. We restore them.
        ═══════════════════════════════════════════════════════════════ */

        /* Restore ant-menu-title-content visibility in collapsed mode */
        .ant-menu-inline-collapsed .ant-menu-item .ant-menu-title-content,
        .ant-menu-inline-collapsed .ant-menu-submenu-title .ant-menu-title-content {
          opacity: 1 !important;
          max-width: none !important;
          overflow: visible !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 100% !important;
          transition: none !important;
        }

        /* Center the inner flex span that wraps the icon — remove cramped minHeight */
        .ant-menu-inline-collapsed .ant-menu-item .ant-menu-title-content > span,
        .ant-menu-inline-collapsed .ant-menu-submenu-title .ant-menu-title-content > span {
          justify-content: center !important;
          min-height: unset !important;
          height: auto !important;
          width: 100% !important;
          gap: 0 !important;
        }

        /* Remove forced padding-left in collapsed state so icon centers naturally */
        .ant-menu-inline-collapsed.ant-menu-vertical .ant-menu-item,
        .ant-menu-inline-collapsed.ant-menu-vertical .ant-menu-submenu-title {
          padding-left: 0 !important;
          padding-right: 0 !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          /* Comfortable height for collapsed items: less cramped */
          height: 44px !important;
          line-height: 44px !important;
          margin: 2px 6px !important;
          border-radius: 8px !important;
          width: calc(100% - 12px) !important;
        }

        /* Hover effect for collapsed items */
        .ant-menu-inline-collapsed.ant-menu-vertical .ant-menu-item:hover,
        .ant-menu-inline-collapsed.ant-menu-vertical .ant-menu-submenu-title:hover {
          background: rgba(255,255,255,0.08) !important;
        }

        /* Selected state for collapsed items */
        .ant-menu-inline-collapsed.ant-menu-vertical .ant-menu-item-selected,
        .ant-menu-inline-collapsed.ant-menu-vertical li.ant-menu-item-selected {
          background: rgba(255,255,255,0.12) !important;
          border-left: none !important;
        }

        /* ═══════════════════════════════════════════════════════════════ */

        /* move front arrow to back */ 
        .ant-menu-submenu-inline > .ant-menu-submenu-title .ant-menu-submenu-arrow {
        right: 22px !important;
        left: auto !important;
        }
        /* move padding-left to 20px — only for non-collapsed (expanded) state */
        .ant-layout-sider .ant-menu-vertical:not(.ant-menu-inline-collapsed) .ant-menu-item,
        .ant-layout-sider .ant-menu-vertical-left .ant-menu-item,
        .ant-layout-sider .ant-menu-vertical-right .ant-menu-item,
        .ant-layout-sider .ant-menu-inline .ant-menu-item,
        .ant-layout-sider .ant-menu-vertical:not(.ant-menu-inline-collapsed) .ant-menu-submenu-title,
        .ant-layout-sider .ant-menu-vertical-left .ant-menu-submenu-title,
        .ant-layout-sider .ant-menu-vertical-right .ant-menu-submenu-title,
        .ant-layout-sider .ant-menu-inline .ant-menu-submenu-title,
        .ant-drawer .ant-menu-vertical:not(.ant-menu-inline-collapsed) .ant-menu-item,
        .ant-drawer .ant-menu-vertical-left .ant-menu-item,
        .ant-drawer .ant-menu-vertical-right .ant-menu-item,
        .ant-drawer .ant-menu-inline .ant-menu-item,
        .ant-drawer .ant-menu-vertical:not(.ant-menu-inline-collapsed) .ant-menu-submenu-title,
        .ant-drawer .ant-menu-vertical-left .ant-menu-submenu-title,
        .ant-drawer .ant-menu-vertical-right .ant-menu-submenu-title,
        .ant-drawer .ant-menu-inline .ant-menu-submenu-title {
          padding-left: 24px !important;
        }

        /* remove child padding */
        .ant-layout-sider .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item,
        .ant-drawer .ant-menu-submenu > .ant-menu.ant-menu-sub .ant-menu-item {
          padding-left: 40px !important;
        }

        /* 2070 WORLD CLASS ICON STYLING & ANIMATIONS */
        .ant-menu-dark .ant-menu-item svg,
        .ant-menu-dark .ant-menu-submenu-title svg {
          filter: drop-shadow(0 0 2px rgba(255, 255, 255, 0.2)) !important;
          transition: all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) !important; /* Sophisticated spring/bounce */
        }

        /* Elegant Hover Glow */
        .ant-menu-dark .ant-menu-item:hover svg,
        .ant-menu-dark .ant-menu-submenu-title:hover svg {
          transform: scale(1.15) translateZ(0) !important;
          filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.8)) !important;
        }

        /* Active Item - Deep Sophisticated Glow */
        .ant-menu-dark .ant-menu-item-selected svg {
          filter: drop-shadow(0 0 12px rgba(255, 255, 255, 0.9)) !important;
          transform: scale(1.1) translateZ(0) !important;
        }

        /* Subtle text glow on hover */
        .ant-menu-dark .ant-menu-item:hover span,
        .ant-menu-dark .ant-menu-submenu-title:hover span {
          text-shadow: 0 0 5px rgba(255, 255, 255, 0.3);
          transition: text-shadow 0.3s ease;
        }
      `}</style>
      <CloseShiftModal
        isModalVisible={isCloseShiftModalVisible}
        setIsModalVisible={setIsCloseShiftModalVisible}
      />
    </SidebarTooltipDisabledContext.Provider>
  );
};

SidebarContent.propTypes = {};
export default SidebarContent;
